import type * as React from 'react';

interface CabecalhoPaginaProps {
  titulo: string;
  descricao?: string;
  acoes?: React.ReactNode;
}

export function CabecalhoPagina({ titulo, descricao, acoes }: CabecalhoPaginaProps) {
  return (
    <header className="mb-5 flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 className="text-xl font-semibold tracking-tight">{titulo}</h1>
        {descricao && <p className="text-silenciado-texto mt-0.5 text-sm">{descricao}</p>}
      </div>
      {/* No celular as ações caem para a linha de baixo e ocupam a largura
          disponível, em vez de espremer o título contra a borda. */}
      {acoes && <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">{acoes}</div>}
    </header>
  );
}
